document.addEventListener('click', (e) => {
    if (e.target.classList.contains('tab')) {
        const tab = e.target
        // Makes sure the tab only affects the tabs inside the same tab-list
        const parent = tab.parentNode.parentNode

        const tabs = parent.querySelectorAll('.tab')
        const tabContents = parent.querySelectorAll('.tab-content')

        tabs.forEach((tab) => {
            tab.classList.remove('active')
        })
        tab.classList.add('active')

        tabContents.forEach((tabContent) => {
            tabContent.classList.remove('active')

            if (tabContent.dataset.tab === tab.dataset.tab) {
                tabContent.classList.add('active')
            }
        })
    }
})
